import {ADD_WORKBOOK_INFO, GET_CBC_FORMS_SUCCESS, SpreadsheetActions} from './spreadsheet.action';
import {QueryModel} from '@shared/models/query-model';

export class WorkbookInfo {
  workbookId: string;
  worksheetId: string;
}

export interface SpreadsheetState {
  workbookInfo: any;
  cbcForms: [key: string];
}

export const initialState = <SpreadsheetState>{
  workbookInfo: {workbookId: null, worksheetId: null},
  cbcForms: {}
};

export function SpreadsheetReducer(state: SpreadsheetState = initialState, action: SpreadsheetActions) {
  switch(action.type) {
    case ADD_WORKBOOK_INFO:
      const workbookId = action.workbookId;
      const worksheetId = action.worksheetId;
      const workbookInfo = {workbookId, worksheetId};
      return {...state, workbookInfo};
    case GET_CBC_FORMS_SUCCESS:
      const countryCode = action.countryCode;
      const forms = action.cbcForms;
      const newState = {...state};
      newState.cbcForms[countryCode] = forms;
      return newState;
    default:
      return state;
  }
}
